export function poorNetMsg() {
  return `Resources have failed to be delivered. You may need to re-do the last action or re-load the page.
If the issue persists, please contact the network administrators.`;
}

export const badNetTitle = 'Poor network quality detected';

export const websocketsAreUnstableMsg = 'Websockets are unstable. If the issue persists, please contact the network administrators.';
